import { render, staticRenderFns } from "./AdminSpecialistTravelMenu.vue?vue&type=template&id=aa3f9e74"
import script from "./AdminSpecialistTravelMenu.vue?vue&type=script&lang=js"
export * from "./AdminSpecialistTravelMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports